import { getFeatureConfig } from '@luna/feature-config';
import { isFeatureEnabled } from '@luna/gatekeeper';
import { generatePath } from '@luna/router';
import type { Country } from '@shared/info-api';

import type { Address } from '../ContactTypes';
import { formatAddress } from '../AddressesService';
import type { ContactItemPropTypes } from './ContactSelectService';
import { addBackUrlQueryParamToUrl } from './ContactSelectService';
import { CDM_ABSOLUTE_PATH } from '../ContactDataManagementPaths';

export function convertAddressesToSelectItems(
    addresses: Address[],
    countries: Country[],
): ContactItemPropTypes[] {
    return addresses.map((address) => ({
        label: formatAddress(address, countries),
        value: address.id,
        isInvalid: address.isInvalid,
    }));
}

export function getAddNewAddressHref(backUrl?: string): string {
    if (isFeatureEnabled((f) => f.contactDataManagement)) {
        if (getFeatureConfig((config) => config.contactDataManagement.address.poBoxType)) {
            return addBackUrlQueryParamToUrl(CDM_ABSOLUTE_PATH.NEW_CONTACT_TYPE_SELECTOR, backUrl);
        }

        return addBackUrlQueryParamToUrl(
            generatePath(CDM_ABSOLUTE_PATH.NEW_CONTACT, { contactType: 'address' }),
            backUrl,
        );
    }

    return '#/settings/contacts';
}
